import React, { useContext, useState } from 'react'

import { PACKAGE_STATUSES, PACKAGE_STATUSES_NAMES } from '../../constants/packageStatus'
import { DataContext } from '../../context/DataContext'
import { clickAndCollectStates, homeDeliveryStates } from '../../helpers/states'
import { formatHoverDate, parseDate } from '../../utils/dates'

import TextBalloon from '../shared/TextBalloon'

const getParsedHistory = (sale: Sale, states: any[], currentStatusIndex: number) => {
  const history: PackageHistory[] = []
  states.slice(0, currentStatusIndex + 1).forEach((state) => {
    const foundHistoryElement = sale.packageHistory.find(({ packageStatus }) => (packageStatus === state.value))
    const historyElement = (foundHistoryElement || history[history.length - 1] || sale.packageHistory[0])
    history.push({ ...historyElement, packageStatus: state.value })
  })
  return history
}

const TimeLine: React.FC = () => {
  const { sale, companyColor } = useContext(DataContext)
  const states = sale?.clickAndCollect
    ? clickAndCollectStates()
    : homeDeliveryStates()
  const currentStatusIndex = PACKAGE_STATUSES[
    sale?.packageStatus as keyof typeof PACKAGE_STATUSES
  ]
  const history = getParsedHistory(sale, states, currentStatusIndex)

  const [hovered, setHovered] = useState<number | null>(null)

  return (
    <div className="flex w-full h-full justify-center text-xs sm:text-sm">
      {sale?.packageStatus && (
        <div className="w-[80%]">
          <div className="flex justify-center">
            {states.map((status) => {
              const index = PACKAGE_STATUSES[status.value as keyof typeof PACKAGE_STATUSES] || 0
              const isPrevious = index <= currentStatusIndex
              const isActive = index === currentStatusIndex
              return (
                <div
                  key={status.value}
                  className="relative flex flex-1 h-full flex-col items-center px-1 landscape:pt-12 portrait:pt-2"
                >
                  {/* Línea */}
                  {index !== 0 && (
                    <div
                      className={`absolute landscape:top-[54px] portrait:top-[13px] right-1/2 h-[2px] w-full ${
                        isPrevious ? '' : 'bg-gray-300'
                      }`}
                      style={{
                        backgroundColor: isPrevious
                          ? companyColor
                          : undefined
                      }}
                    />
                  )}

                  <div className="relative z-10 mb-1 flex items-center justify-center">
                    {/* Punto */}
                    <div
                      className={`landscape:h-4 landscape:w-4 portrait:h-3 portrait:w-3 rounded-full border-2 border-white ${
                        isPrevious ? '' : 'bg-gray-300'
                      }`}
                      onMouseEnter={() => isPrevious && setHovered(index)}
                      onMouseLeave={() => isPrevious && setHovered(null)}
                      style={isPrevious ? { backgroundColor: companyColor } : {}}
                    />

                    {/* Globo */}
                    {isPrevious && hovered === index && (
                      <TextBalloon>
                        <p className="text-lg font-semibold whitespace-nowrap">
                          {PACKAGE_STATUSES_NAMES[status.value as keyof typeof PACKAGE_STATUSES_NAMES]}
                        </p>
                        <p className="text-sm text-gray-500 whitespace-nowrap">
                          {
                            formatHoverDate(parseDate(history[index]?.date || history[history.length - 1]?.date, 1))
                          }
                        </p>
                      </TextBalloon>
                      )}
                  </div>

                  {/* Icono */}
                  {isActive &&
                  <div
                    className="rounded-full flex justify-center w-12 h-12 p-2 landscape:top-8 portrait:-top-2 absolute z-10"
                    style={{ backgroundColor: companyColor }}
                  >
                    <img
                      src={status.activeIcon}
                      alt={status.name}
                      className="w-8 h-8 z-20"
                    />
                  </div>}
                </div>
              )
            })}
          </div>
        </div>
      )}
    </div>
  )
}

export default TimeLine
